<template>
  <div class="media align-items-start mt-20 mb-55">
    <div class="media-left mr-25">
      <figure class="image is-64x64" style="margin-top: 6px;">
        <router-link v-if="authorId && authorId !== ''" :to="{ name: 'CustomerReviewList', params: { customer_id: authorId } }">
          <img
            :src="authorAvatar || require('@/assets/images/user_default.svg')"
            alt="..."
            class="img-thumbnail is-rounded"
          />
        </router-link>
        <img
          v-else
          :src="authorAvatar || require('@/assets/images/user_default.svg')"
          alt="..."
          class="img-thumbnail is-rounded"
        />
      </figure>
    </div>
    <div class="media-content content-short">
      <nav class="level mb-0">
        <!-- Left side -->
        <div class="level-left">
          <p v-if="authorName && authorName.length" class="qa-label"><router-link :to="{ name: 'CustomerReviewList', params: { customer_id: authorId } }"><span>{{ authorName }}</span></router-link> {{ authorIndividual }}</p>
        </div>

        <!-- Right side -->
        <div class="level-right">
          <p class="font-small c-text-grey4 mb-5">{{ time }}</p>
        </div>
      </nav>
      <div v-if="content && content.length" :class="{'is-outline': (type === 'answer')}" class="talk-bubble">
        <div class="content">{{ content }}</div>
        <div class="actions text-right">
          <router-link v-if="isEdit && type === 'answer'" :to="{ name: 'AnswerEdit', params: { id: answer.questionId , answerId: id } }" class="editable"><i class="fas fa-pencil-alt mr-5"></i>編集</router-link>
          <router-link v-else-if="isEdit" :to="{ name: 'QuestionEdit', params: { id: id } }" class="editable"><i class="fas fa-pencil-alt mr-5"></i>編集</router-link>
          <button v-show="!isResolved && type === 'answer' && !answer.bestAnswer && isOwner" class="button is-primary" @click="onClick(id)"><IconCrown width="17" height="14" class="mr-3"/>ベストアンサーに選ぶ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCrown from '@/components/common/icon-crown';

export default {
  name: 'QAContentItem',
  components: {
    IconCrown
  },
  props: {
    type: {
      type: String,
      default: 'question'
    },
    id: {
      type: [String, Object, Number],
      default: null
    },
    authorAvatar: {
      type: String,
      default: () => require('@/assets/images/user_default.svg')
    },
    authorId: {
      type: String,
      default: ''
    },
    authorName: {
      type: String,
      default: ''
    },
    authorIndividual: {
      type: String,
      default: 'さん'
    },
    date: {
      type: [String, Number],
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    answer: {
      type: Object,
      default: () => ({
        questionId: null,
        bestAnswer: false
      })
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    isOwner: {
      type: Boolean,
      default: () => false
    },
    isResolved: {
      type: Boolean,
      default: () => false
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    time: function() {
      let result = '';

      if (!this.date) return result;

      if (typeof this.date === 'number') {
        result = this.$moment(new Date(this.date * 1000)).format('YYYY/M/D');
      } else if (typeof this.date === 'string' && this.date.length === 10) {
        result = this.$moment(new Date(parseInt(this.date) * 1000)).format('YYYY/M/D');
      } else {
        result = this.$moment(new Date(this.date)).format('YYYY/M/D');
      }

      return result;
    }
  }
};
</script>
